module.exports = __webpack_public_path__ + "img/logoBoardData.a5f3b0b4.png";